module.exports = __webpack_public_path__ + "img/certification.220a87b6.png";